import React from 'react';
import Avatar from '@/Components/Avatar';
import { createReadableDistanceString } from '@/utils/time';

export default function Comment({
  comment,
  isLast,
}: {
  comment: App.Data.CommentData,
  isLast?: boolean,
}) {
  return (
    <>
      <div className="flex items-stretch">
        <div className="relative pt-2 mr-3">
          <Avatar
            user={comment.user}
            displayName={false}
            disableLink={true}
          />
          {!isLast && (
            <div className="absolute left-1/2 top-8 h-4/6 w-px dark:bg-brand-light-20"></div>
          )}
        </div>
        <div className="w-full px-2 pt-3 dark:text-brand-light-100 dark:bg-brand-dark-50 rounded-lg shadow-lg">
          <div className="flex justify-between items-center">
            <div className="pl-2">
              <Avatar
                user={comment.user}
                displayPhoto={false}
                disableLink={true}
              />
            </div>
            <p className="text-sm dark:text-brand-light-50">
              {createReadableDistanceString(new Date(comment.created_at))}
            </p>
          </div>
          <p className="pl-2 py-2 text-lg">
            {comment.comment}
          </p>
        </div>
      </div>
    </>
  )
}